import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F37.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame37() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);


        return (
            <div className="F37_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F37_entryBox">
                    <div className="F37_paragraph">
                        {language === 'english' ?
                            <p className="F37_paragraphEnglish">Saira is still inquisitive, what if she had forgotten to keep the sanitary pad with her, and what if she needed more than one sanitary pad if she was outside.</p>
                            :
                            <p className="F37_paragraphUrdu">سائرہ کے دماغ میں اب اور بھی سوال جنم لے رہے ہیں وہ یہ سوچ رہی ہے کہ ایسی صورتحال میں کیا ہو سکتا ہے اگر وہ گھر سے پیڈ لانا بھول جائے یا اسے اسکول کے دوران ایک سے زیادہ پیڈ کی ضرورت پڑ جائے۔</p>
                        }
                    </div>

                    <div className="F37_timeline">
                        <div className='F37_timelineBar'>
                            <div className='F37_timelineFill'></div>
                            <span className='F37_timelineText'>11/19</span>
                        </div>
                    </div>

                    <div className="F37_nextFrames">
                        <div className="F37_nextFrame1"></div>
                        <div className="F37_nextFrame2"></div>
                        <div className="F37_nextFrame3"></div>
                    </div>

                    <div className='F37_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(11)) }} className='F37_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame37;